/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    function TermsConditionsHistoryFacadeModel(options) {
        var defaults = {
            Date: null,
            IsAccepted: false,
            ProcessObjectID: 0,
            ParagraphSortOrder: 0,
            ObjectDescription: '',
            IsLatest: false,
            LocationID: 0,
            TermsConditionsDocumentID: 0,
            TermsConditionsParagraphVersionID: 0,
            PersonID: null,
            ProcessTypeID: 0,
            ID: 0,
            GID: null,
            CreatedBy: null,
            DateCreated: null,
            ModifiedBy: null,
            DateModified: null,
            APILink: '',
        };

        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        // ATO Properties
        this.APILink = ko.observable(settings.APILink);

        // Properties as Observables
        this.Date = ko.validatedObservable(settings.Date);
        this.IsAccepted = ko.validatedObservable(settings.IsAccepted);
        this.ProcessObjectID = ko.validatedObservable(settings.ProcessObjectID);
        this.ParagraphSortOrder = ko.validatedObservable(settings.ParagraphSortOrder);
        this.ObjectDescription = ko.validatedObservable(settings.ObjectDescription);
        this.IsLatest = ko.validatedObservable(settings.IsLatest);
        this.LocationID = ko.validatedObservable(settings.LocationID);
        this.TermsConditionsDocumentID = ko.validatedObservable(settings.TermsConditionsDocumentID);
        this.TermsConditionsParagraphVersionID = ko.validatedObservable(settings.TermsConditionsParagraphVersionID);
        this.PersonID = ko.validatedObservable(settings.PersonID);
        this.ProcessTypeID = ko.validatedObservable(settings.ProcessTypeID);
        this.ID = ko.validatedObservable(settings.ID);
        this.GID = ko.validatedObservable(settings.GID);
        this.CreatedBy = ko.validatedObservable(settings.CreatedBy);
        this.DateCreated = ko.validatedObservable(settings.DateCreated);
        this.ModifiedBy = ko.validatedObservable(settings.ModifiedBy);
        this.DateModified = ko.validatedObservable(settings.DateModified);

        // Relationships as Observables and ObservableArrays
        this.Location = ko.observable();
        this.TermsConditionsDocument = ko.observable();
        this.TermsConditionsParagraphVersion = ko.observable();
        this.Person = ko.observable();
        this.ProcessType = ko.observable();

        // Load from API Response Models
        this.LoadFromResponse = function (responseData) {
            var loaded = this;

            if (responseData.APILink != undefined) {
                loaded.APILink(responseData.APILink);
            }

            if (responseData.Date != undefined) {
                loaded.Date(responseData.Date);
            }
            if (responseData.IsAccepted != undefined) {
                loaded.IsAccepted(responseData.IsAccepted);
            }
            if (responseData.ProcessObjectID != undefined) {
                loaded.ProcessObjectID(responseData.ProcessObjectID);
            }
            if (responseData.ParagraphSortOrder != undefined) {
                loaded.ParagraphSortOrder(responseData.ParagraphSortOrder);
            }
            if (responseData.ObjectDescription != undefined) {
                loaded.ObjectDescription(responseData.ObjectDescription);
            }
            if (responseData.IsLatest != undefined) {
                loaded.IsLatest(responseData.IsLatest);
            }
            if (responseData.LocationID != undefined) {
                loaded.LocationID(responseData.LocationID);
            }
            if (responseData.TermsConditionsDocumentID != undefined) {
                loaded.TermsConditionsDocumentID(responseData.TermsConditionsDocumentID);
            }
            if (responseData.TermsConditionsParagraphVersionID != undefined) {
                loaded.TermsConditionsParagraphVersionID(responseData.TermsConditionsParagraphVersionID);
            }
            if (responseData.PersonID != undefined) {
                loaded.PersonID(responseData.PersonID);
            }
            if (responseData.ProcessTypeID != undefined) {
                loaded.ProcessTypeID(responseData.ProcessTypeID);
            }
            if (responseData.ID != undefined) {
                loaded.ID(responseData.ID);
            }
            if (responseData.GID != undefined) {
                loaded.GID(responseData.GID);
            }
            if (responseData.CreatedBy != undefined) {
                loaded.CreatedBy(responseData.CreatedBy);
            }
            if (responseData.DateCreated != undefined) {
                loaded.DateCreated(responseData.DateCreated);
            }
            if (responseData.ModifiedBy != undefined) {
                loaded.ModifiedBy(responseData.ModifiedBy);
            }
            if (responseData.DateModified != undefined) {
                loaded.DateModified(responseData.DateModified);
            }
            if (responseData.Location != null) {
                loaded.Location(new smapi.communication.TermsConditionsLocationModel().LoadFromResponse(responseData.Location));
            }
            if (responseData.TermsConditionsDocument != null) {
                loaded.TermsConditionsDocument(new smapi.communication.TermsConditionsDocumentModel().LoadFromResponse(responseData.TermsConditionsDocument));
            }
            if (responseData.TermsConditionsParagraphVersion != null) {
                loaded.TermsConditionsParagraphVersion(new smapi.communication.TermsConditionsParagraphVersionModel().LoadFromResponse(responseData.TermsConditionsParagraphVersion));
            }
            if (responseData.Person != null) {
                loaded.Person(new smapi.community.PersonModel().LoadFromResponse(responseData.Person));
            }
            if (responseData.ProcessType != null) {
                loaded.ProcessType(new smapi.communication.TermsConditionsProcessTypeModel().LoadFromResponse(responseData.ProcessType));
            }
            return loaded;
        };

        // Load from the APILink property
        this.LoadFromLink = function (baseApiUrl) {
            smapi.access.getById(baseApiUrl, 'TRS.CAMS.Communication.Entity.TermsConditionsHistory', function (data, textStatus, jqXHR) {
                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                // handle the result
                if ((container != null && container.Status == "success") || jqXHR.statusText == "OK" || jqXHR.statusText == "No Content") {
                    // Execute the Loader
                    self.LoadFromResponse(container.Payload);
                }
            });
        }

        this.Date.extend({
            date: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.IsAccepted.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.ProcessObjectID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ParagraphSortOrder.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ObjectDescription.extend({
            maxLength: {
                params: 1000,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '1000')
            }
        });
        this.IsLatest.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        this.LocationID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TermsConditionsDocumentID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.TermsConditionsParagraphVersionID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PersonID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ProcessTypeID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.GID.extend({
            required: {
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            pattern: {
                params: /^[{(]?[0-9A-F]{8}[-]?([0-9A-F]{4}[-]?){3}[0-9A-F]{12}[)}]?$/,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_ErrorInFormat0_Key), 'b5190af9-07b2-4e1e-a556-29b25a075df8')
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);

        // Check if Model is valid 
        // Will NOT validate recursive attached models, unless we turn that ON in the inital config of KO
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };

        return self;
    }

    jQuery.extend(true, sm.portal.vm, {
        TermsConditionsHistoryFacadeModel: TermsConditionsHistoryFacadeModel
    });

})(jQuery);